module.exports = require("@swa-ui/core/src/InformationTip/InformationTip.module.scss");